<template>
<div>
    <div class="d-flex justify-end mt-8" v-if="$vuetify.breakpoint.smAndUp">
        <div class="caption pl-2" style="position:fixed; border-left:2px solid #CCCCCC">
            <Dim text="Photo" @pushed="go('init')" />
            <Dim text="Name" @pushed="go('name')" />
            <Dim text="Headline" @pushed="go('headline')" />
            <Dim text="Location" @pushed="go('location')" />
            <Dim text="Contact Info" @pushed="go('contactInfo')" />
            <Dim text="Providing Services" @pushed="go('providingServices')" />

            <div class="font-weight-medium grey--text mt-3 mb-n1">ABOUT</div>
            <Dim text="About" @pushed="go('about')" />
            <Dim text="Skills & Endorsments" @pushed="go('skills')" />
            <Dim text="Activity" @pushed="go('activity')" />
            <Dim text="Interests" @pushed="go('interests')" />
            <Dim text="Languages" @pushed="go('languages')" />
            

            <div class="font-weight-medium grey--text mt-3 mb-n1">BACKGROUND</div>
            <Dim text="Experience" @pushed="go('experience')" />
            <Dim text="Volunteer Experience" @pushed="go('volunteerExperience')" />
            <Dim text="Education" @pushed="go('education')" />
            <Dim text="Organizations" @pushed="go('organizations')" />
            <Dim text="Publications" @pushed="go('publications')" />

            <div class="font-weight-medium grey--text mt-3 mb-n1">ACCOMPLISMENTS</div>
            <Dim text="Courses" @pushed="go('courses')" />
            <Dim text="Projects" @pushed="go('projects')" />
            <Dim text="Honors & Awards" @pushed="go('honors')" />
        </div>
    </div>

    <!-- SEND -->
    <v-row class="mt-n2">
        <v-col cols="12" offset-sm="1" sm="9" offset-md="2" md="8">
            <div class="text-right">
                <v-btn depressed large class="accent" @click="validate" :disabled="sending">save my reputation planner</v-btn>
            </div>
        </v-col>
    </v-row>
    
    <!-- NAME -->
    <v-row class="mt-1" id="name">
        <v-col cols="12" sm="2">
            <Title text="NAME *" desc="No nicknames"/>
        </v-col>
        <v-col cols="12" sm="8">
            <v-text-field
                v-model="model.name"
                outlined dense
                @keydown.enter="validate"
                class="mt-n4 mt-sm-0">
            </v-text-field>
        </v-col>
    </v-row>

    <!-- HEADLINE -->
    <v-row class="mt-n5" id="headline">
        <v-col cols="12" sm="2">
            <Title text="HEADLINE" desc="Who are you?" />
        </v-col>
        <v-col cols="12" sm="8">
            <vue-editor v-model="model.headline" :editor-toolbar="customToolbarQuill" class="mt-n4 mt-sm-0" />
        </v-col>
    </v-row>

    <!-- LOCATION -->
    <v-row class="mt-2" id="location">
        <v-col cols="12" sm="2">
            <Title text="LOCATION" />
        </v-col>
        <v-col cols="12" sm="8">
            <v-text-field
                v-model="model.location"
                outlined dense
                class="mt-n4 mt-sm-0">
            </v-text-field>
        </v-col>
    </v-row>

    <!-- CONTACT INFO -->
    <v-row class="mt-n5" id="contactInfo">
        <v-col cols="12" sm="2">
            <Title text="CONTACT INFO" />
        </v-col>
        <v-col cols="12" sm="8">
            <vue-editor v-model="model.contactInfo" :editor-toolbar="customToolbarQuill" class="mt-n4 mt-sm-0" />
        </v-col>
    </v-row>

    <!-- PROVIDING SERVICES -->
    <v-row class="mt-2" id="providingServices">
        <v-col cols="12" sm="2">
            <Title text="PROVIDING SERVICES" />
        </v-col>
        <v-col cols="12" sm="8">
            <vue-editor v-model="model.providingServices" :editor-toolbar="customToolbarQuill" class="mt-n4 mt-sm-0" />
        </v-col>
    </v-row>



    <!-- TITLE: ABOUT -->
    <v-row class="mt-2">
        <v-col cols="12" sm="3">
            <div class="body-1 font-weight-medium text-left text-sm-center accent--text">ABOUT</div>
        </v-col>
    </v-row>

    <!-- ABOUT -->
    <v-row class="mt-2" id="about">
        <v-col cols="12" sm="2">
            <Title text="ABOUT" />
        </v-col>
        <v-col cols="12" sm="8">
            <vue-editor v-model="model.about" :editor-toolbar="customToolbarQuill" class="mt-n4 mt-sm-0" />
        </v-col>
    </v-row>

    <!-- SKILLS & ENDORSMENTS -->
    <v-row class="mt-2" id="skills">
        <v-col cols="12" sm="2">
            <Title text="SKILLS & ENDORSMENTS" />
        </v-col>
        <v-col cols="12" sm="8">
            <vue-editor v-model="model.skills" :editor-toolbar="customToolbarQuill" class="mt-n4 mt-sm-0" />
        </v-col>
    </v-row>

    <!-- ACTIVITY -->
    <v-row class="mt-2" id="activity">
        <v-col cols="12" sm="2">
            <Title text="ACTIVITY" desc="Blog, Youtube channel, Twitter, etc." />
        </v-col>
        <v-col cols="12" sm="8">
            <vue-editor v-model="model.activity" :editor-toolbar="customToolbarQuill" class="mt-n4 mt-sm-0" />
        </v-col>
    </v-row>

    <!-- INTERESTS -->
    <v-row id="interests">
        <v-col cols="12" sm="2">
            <Title text="INTERESTS" />
        </v-col>
        <v-col cols="12" sm="8">
            <vue-editor v-model="model.interests" :editor-toolbar="customToolbarQuill" class="mt-n4 mt-sm-0" />
        </v-col>
    </v-row>

    <!-- LANGUAGES -->
    <v-row class="mt-2" id="languages">
        <v-col cols="12" sm="2">
            <Title text="LANGUAGES" />
        </v-col>
        <v-col cols="12" sm="8">
            <vue-editor v-model="model.languages" :editor-toolbar="customToolbarQuill" class="mt-n4 mt-sm-0" />
        </v-col>
    </v-row>

    

    <!-- TITLE: BACKGROUND -->
    <v-row class="mt-2">
        <v-col cols="12" sm="3">
            <div class="body-1 font-weight-medium text-left text-sm-center accent--text">BACKGROUND</div>
        </v-col>
    </v-row>

    <!-- EXPERIENCE -->
    <v-row id="experience">
        <v-col cols="12" sm="2">
            <Title text="EXPERIENCE" />
        </v-col>
        <v-col cols="12" sm="8">
            <vue-editor v-model="model.experience" :editor-toolbar="customToolbarQuill" class="mt-n4 mt-sm-0" />
        </v-col>
    </v-row>

    <!-- VOLUNTEER EXPERIENCE -->
    <v-row class="mt-2" id="volunteerExperience">
        <v-col cols="12" sm="2">
            <Title text="VOLUNTEER EXPERIENCE" />
        </v-col>
        <v-col cols="12" sm="8">
            <vue-editor v-model="model.volunteerExperience" :editor-toolbar="customToolbarQuill" class="mt-n4 mt-sm-0" />
        </v-col>
    </v-row>

    <!-- EDUCATION -->
    <v-row class="mt-2" id="education">
        <v-col cols="12" sm="2">
            <Title text="EDUCATION" />
        </v-col>
        <v-col cols="12" sm="8">
            <vue-editor v-model="model.education" :editor-toolbar="customToolbarQuill" class="mt-n4 mt-sm-0" />
        </v-col>
    </v-row>

    <!-- ORGANIZATIONS & CLUBS -->
    <v-row class="mt-2" id="organizations">
        <v-col cols="12" sm="2">
            <Title text="ORGANIZATIONS & CLUBS" />
        </v-col>
        <v-col cols="12" sm="8">
            <vue-editor v-model="model.organizations" :editor-toolbar="customToolbarQuill" class="mt-n4 mt-sm-0" />
        </v-col>
    </v-row>

    <!-- PUBLICATIONS -->
    <v-row class="mt-2" id="publications">
        <v-col cols="12" sm="2">
            <Title text="PUBLICATIONS" />
        </v-col>
        <v-col cols="12" sm="8">
            <vue-editor v-model="model.publications" :editor-toolbar="customToolbarQuill" class="mt-n4 mt-sm-0" />
        </v-col>
    </v-row>



    <!-- TITLE: ACCOMPLISMENTS -->
    <v-row class="mt-2">
        <v-col cols="12" sm="3">
            <div class="body-1 font-weight-medium text-left text-sm-center accent--text">ACCOMPLISMENTS</div>
        </v-col>
    </v-row>

    <!-- COURSES -->
    <v-row id="courses">
        <v-col cols="12" sm="2">
            <Title text="COURSES" />
        </v-col>
        <v-col cols="12" sm="8">
            <vue-editor v-model="model.courses" :editor-toolbar="customToolbarQuill" class="mt-n4 mt-sm-0" />
        </v-col>
    </v-row>

    <!-- PROJECTS -->
    <v-row class="mt-2" id="projects">
        <v-col cols="12" sm="2">
            <Title text="PROJECTS"/>
        </v-col>
        <v-col cols="12" sm="8">
            <vue-editor v-model="model.projects" :editor-toolbar="customToolbarQuill" class="mt-n4 mt-sm-0" />
        </v-col>
    </v-row>

    <!-- HONORS AND AWARDS -->
    <v-row class="mt-2" id="honors">
        <v-col cols="12" sm="2">
            <Title text="HONORS AND AWARDS" />
        </v-col>
        <v-col cols="12" sm="8">
            <vue-editor v-model="model.honors" :editor-toolbar="customToolbarQuill" class="mt-n4 mt-sm-0" />
        </v-col>
    </v-row>


    <!-- SEND -->
    <v-row class="mt-2">
        <v-col cols="12" offset-sm="1" sm="9" offset-md="2" md="8">
            <div class="text-right">
                <v-btn large text class="primary--text" @click="$router.push('/planner/p/own')">
                    <v-icon small left>fa-angle-left</v-icon>
                    Back to Planner
                </v-btn>
                <v-btn depressed large class="accent" @click="validate" :disabled="sending">save my reputation planner</v-btn>
            </div>
        </v-col>
    </v-row>
</div>
</template>

<script>
import _ from 'lodash'
import Sign from '@/firebase/sign'
import { VueEditor } from "vue2-editor";
import Title from '@/components/planner/Title'
import Dim from '@/components/planner/Dim'
import Personal from '@/firebase/personal'

export default {
    data: () => ({
        sending: false,
        final: null,
        model: {
            photo: null,
            name: '',
            headline: '',
            location: '',
            contactInfo: '',
            providingServices: '',
            about: '',
            activity: '',
            experience: '',
            education: '',
            skills: '',
            courses: '',
            languages: '',
            volunteerExperience: '',
            projects: '',
            publications: '',
            honors: '',
            organizations: '',
            interests: ''
        },
        content: '',
        customToolbarQuill: [
          [{ 'size': ['small', false, 'large', 'huge'] }],
          ['bold', 'italic', 'underline', 'link'],
          [{ 'color': [] }, { 'background': [] }],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'indent': '-1'}, { 'indent': '+1' }]
        ],
        optionsScroll: {
            duration: 800,
            offset: 0,
            easing: 'easeInOutCubic'
        }
    }),
    components: {
        Title,
        VueEditor,
        Dim
    },
    mounted() {
        if (this.user.planner) {
            this.model = _.merge(this.model, this.user.planner);
        }
    },
    methods: {
        go(str) {
            this.$vuetify.goTo('#'+str, this.optionsScroll)
        },
        validate() {
            if (this.validateIsEmpty(this.model.name)) {
                this.$store.dispatch('setSnack', {kind:'error', text:'Name is required'});
                return;
            }

            this.sending = true;
            this.prepare();
            this.save();
        },
        prepare() {
            this.final = this.model;

            for (let key in this.final) {
                if (this.validateIsEmpty(this.final[key])) {
                    delete this.final[key];
                }
            }
        },
        save() {
            Personal.updatePlanner(this.user.uid, this.final)
                    .then(response => {
                        if (response === true) {
                            Sign.reInitUser(this.user.uid);
                            this.$store.dispatch('setSnack', {kind:'success', text:'My Reputation Planner has been updated.'});
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
                        }
                        this.sending = false;
                    });
        }
    }
}
</script>